import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ConsentsService {
  data: any;
  optionData:any={};
  constructor(
    private http: HttpService
  ) {  }

  /**
   * It return data stored by setData to consent-confirm component
   */
  getData() {
    return this.data;
  }


  setData(res) {
    this.data = res;
  }

  /**
   * 
   * @param options -object containing :
   * {type of consent:active or request
   *  id: consentId
   * }
   */
  getConsents() {
    // this.activatedRoute.paramMap.pipe(
    //   switchMap((params: ParamMap) => {
    //     this.optionData.id = +params.get('id');
    //     this.optionData.consentType=params.get('consentType');
    //     return this.optionData;
    //   })
    // );
   
  }

  consentUpdate(data, callback?: any) {
    let options = {
      type :'post',
      url  :'consentUpdate',
      includeUserSession: true,
      data: data
    }
    this.http.makeHttpRequest(options).subscribe(res => {
      if (res != undefined) {
        callback(res);
      }
    });
  }

  getPopupContent( type ) {
    var popuptext;
    switch (type) {
      case "Confirm":
        popuptext = {
          body: "Please Enter Your Consent PIN to Confirm Consent(s)",
          heading: "Consent Confirmation"
        }
        break;
      case "Decline":
        popuptext = {
          body: "Please Enter Your Consent PIN to Decline Consent(s)",
          heading: "Consent Decline"
        }
        break;
      case "Delink":
        popuptext = {
          body: "Please Enter Your Consent PIN to Delink Account",
          heading: "Accoount Delink"
        }
        break;
      case "REVOKED":
        popuptext = {
          body: "Please Enter Your Consent PIN to Revoke Consent(s)",
          heading: "Consent Revoke"
        }
        break;
      case "PAUSED":
        popuptext = {
          body: "Please Enter Your Consent PIN to Pause Consent(s)",
          heading: "Consent Pause"
        }
        break;
      case "ACTIVE":
        popuptext = {
          body: "Please Enter Your Consent PIN to Resume Consent(s)",
          heading: "Consent Resume"
        }
        break;
    }
    return popuptext;
  }
}
